/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdditionalCoverageDetail } from './AdditionalCoverageDetail';
import {
    AdditionalCoverageDetailFromJSON,
    AdditionalCoverageDetailFromJSONTyped,
    AdditionalCoverageDetailToJSON,
} from './AdditionalCoverageDetail';
import type { StructuredAnalysisResponseDataCoverageAmounts } from './StructuredAnalysisResponseDataCoverageAmounts';
import {
    StructuredAnalysisResponseDataCoverageAmountsFromJSON,
    StructuredAnalysisResponseDataCoverageAmountsFromJSONTyped,
    StructuredAnalysisResponseDataCoverageAmountsToJSON,
} from './StructuredAnalysisResponseDataCoverageAmounts';
import type { StructuredAnalysisResponseDataCoverageStatus } from './StructuredAnalysisResponseDataCoverageStatus';
import {
    StructuredAnalysisResponseDataCoverageStatusFromJSON,
    StructuredAnalysisResponseDataCoverageStatusFromJSONTyped,
    StructuredAnalysisResponseDataCoverageStatusToJSON,
} from './StructuredAnalysisResponseDataCoverageStatus';
import type { ValueWithNote } from './ValueWithNote';
import {
    ValueWithNoteFromJSON,
    ValueWithNoteFromJSONTyped,
    ValueWithNoteToJSON,
} from './ValueWithNote';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponseData
 */
export interface StructuredAnalysisResponseData {
    /**
     * 
     * @type {StructuredAnalysisResponseDataCoverageStatus}
     * @memberof StructuredAnalysisResponseData
     */
    coverage_status?: StructuredAnalysisResponseDataCoverageStatus;
    /**
     * 
     * @type {StructuredAnalysisResponseDataCoverageAmounts}
     * @memberof StructuredAnalysisResponseData
     */
    coverage_amounts?: StructuredAnalysisResponseDataCoverageAmounts;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseData
     */
    snf_benefit_days?: ValueWithNote;
    /**
     * 
     * @type {Array<AdditionalCoverageDetail>}
     * @memberof StructuredAnalysisResponseData
     */
    additional_coverage_details?: Array<AdditionalCoverageDetail>;
}

/**
 * Check if a given object implements the StructuredAnalysisResponseData interface.
 */
export function instanceOfStructuredAnalysisResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StructuredAnalysisResponseDataFromJSON(json: any): StructuredAnalysisResponseData {
    return StructuredAnalysisResponseDataFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coverage_status': !exists(json, 'coverage_status') ? undefined : StructuredAnalysisResponseDataCoverageStatusFromJSON(json['coverage_status']),
        'coverage_amounts': !exists(json, 'coverage_amounts') ? undefined : StructuredAnalysisResponseDataCoverageAmountsFromJSON(json['coverage_amounts']),
        'snf_benefit_days': !exists(json, 'snf_benefit_days') ? undefined : ValueWithNoteFromJSON(json['snf_benefit_days']),
        'additional_coverage_details': !exists(json, 'additional_coverage_details') ? undefined : ((json['additional_coverage_details'] as Array<any>).map(AdditionalCoverageDetailFromJSON)),
    };
}

export function StructuredAnalysisResponseDataToJSON(value?: StructuredAnalysisResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coverage_status': StructuredAnalysisResponseDataCoverageStatusToJSON(value.coverage_status),
        'coverage_amounts': StructuredAnalysisResponseDataCoverageAmountsToJSON(value.coverage_amounts),
        'snf_benefit_days': ValueWithNoteToJSON(value.snf_benefit_days),
        'additional_coverage_details': value.additional_coverage_details === undefined ? undefined : ((value.additional_coverage_details as Array<any>).map(AdditionalCoverageDetailToJSON)),
    };
}

